import { InjectionToken } from '@angular/core';

/**
 * Local Pages Zip codes
 */

export const localPageZipConstants = {
  AKRON: [
    '43832',
    '43837',
    '43840',
    '43988',
    '44201',
    '44203',
    '44211',
    '44216',
    '44217',
    '44221',
    '44223',
    '44224',
    '44230',
    '44231',
    '44232',
    '44234',
    '44236',
    '44240',
    '44243',
    '44250',
    '44260',
    '44262',
    '44264',
    '44265',
    '44266',
    '44270',
    '44272',
    '44276',
    '44278',
    '44287',
    '44288',
    '44301',
    '44302',
    '44303',
    '44304',
    '44305',
    '44306',
    '44307',
    '44308',
    '44309',
    '44310',
    '44311',
    '44312',
    '44313',
    '44314',
    '44315',
    '44316',
    '44317',
    '44319',
    '44320',
    '44321',
    '44325',
    '44326',
    '44333',
    '44334',
    '44606',
    '44608',
    '44610',
    '44611',
    '44612',
    '44613',
    '44614',
    '44615',
    '44617',
    '44618',
    '44620',
    '44621',
    '44622',
    '44624',
    '44626',
    '44627',
    '44629',
    '44630',
    '44632',
    '44633',
    '44636',
    '44637',
    '44638',
    '44639',
    '44640',
    '44641',
    '44643',
    '44644',
    '44645',
    '44646',
    '44647',
    '44648',
    '44650',
    '44651',
    '44652',
    '44653',
    '44654',
    '44656',
    '44657',
    '44659',
    '44660',
    '44661',
    '44662',
    '44663',
    '44666',
    '44667',
    '44669',
    '44670',
    '44671',
    '44675',
    '44676',
    '44677',
    '44678',
    '44680',
    '44681',
    '44682',
    '44683',
    '44685',
    '44687',
    '44688',
    '44689',
    '44690',
    '44691',
    '44695',
    '44697',
    '44701',
    '44702',
    '44703',
    '44704',
    '44705',
    '44706',
    '44707',
    '44708',
    '44709',
    '44710',
    '44711',
    '44714',
    '44718',
    '44720',
    '44721',
    '44730',
    '44735',
  ],
  COLUMBUS: [
    '43085',
    '43201',
    '43202',
    '43203',
    '43204',
    '43205',
    '43206',
    '43207',
    '43209',
    '43210',
    '43211',
    '43212',
    '43213',
    '43214',
    '43215',
    '43216',
    '43217',
    '43218',
    '43219',
    '43220',
    '43221',
    '43222',
    '43223',
    '43224',
    '43226',
    '43227',
    '43228',
    '43229',
    '43230',
    '43231',
    '43232',
    '43235',
    '43236',
    '43240',
    '43260',
    '43266',
  ],
  ALLENTOWN: [
    '07802',
    '07820',
    '07823',
    '07826',
    '07830',
    '07831',
    '07833',
    '07836',
    '07838',
    '07840',
    '07844',
    '07850',
    '07853',
    '07860',
    '07863',
    '07865',
    '07876',
    '07882',
    '07920',
    '07921',
    '07924',
    '07926',
    '07930',
    '07931',
    '07934',
    '07945',
    '07960',
    '07977',
    '07978',
    '07979',
    '08240',
    '08323',
    '08502',
    '08504',
    '08525',
    '08530',
    '08534',
    '08551',
    '08553',
    '08556',
    '08557',
    '08558',
    '08559',
    '08560',
    '08801',
    '08802',
    '08803',
    '08804',
    '08805',
    '08807',
    '08808',
    '08809',
    '08821',
    '08822',
    '08825',
    '08826',
    '08827',
    '08829',
    '08833',
    '08834',
    '08835',
    '08836',
    '08844',
    '08848',
    '08853',
    '08858',
    '08865',
    '08867',
    '08868',
    '08869',
    '08870',
    '08873',
    '08876',
    '08885',
    '08886',
    '08887',
    '08888',
    '08889',
    '18101',
    '18102',
    '18103',
    '18104',
    '18105',
    '18106',
    '18109',
    '18195',
  ],
  CENTRAL_NEW_JERSEY: [
    '06807',
    '06820',
    '06896',
    '07001',
    '07005',
    '07008',
    '07016',
    '07017',
    '07019',
    '07022',
    '07023',
    '07027',
    '07033',
    '07036',
    '07039',
    '07040',
    '07050',
    '07052',
    '07059',
    '07060',
    '07061',
    '07062',
    '07063',
    '07064',
    '07065',
    '07066',
    '07067',
    '07069',
    '07074',
    '07076',
    '07077',
    '07078',
    '07079',
    '07080',
    '07081',
    '07083',
    '07088',
    '07090',
    '07091',
    '07092',
    '07095',
    '07099',
    '07101',
    '07102',
    '07103',
    '07104',
    '07105',
    '07106',
    '07107',
    '07108',
    '07109',
    '07110',
    '07112',
    '07114',
    '07201',
    '07202',
    '07203',
    '07204',
    '07205',
    '07206',
    '07207',
    '07208',
    '07416',
    '07420',
    '07422',
    '07444',
    '07450',
    '07460',
    '07480',
    '07602',
    '07650',
    '07657',
    '07666',
    '07747',
    '07803',
    '07821',
    '07828',
    '07834',
    '07869',
    '07885',
    '07901',
    '07922',
    '07928',
    '07933',
    '07938',
    '07939',
    '07946',
    '07950',
    '07974',
    '07976',
    '07980',
    '08042',
    '08231',
    '08402',
    '08512',
    '08520',
    '08528',
    '08536',
    '08540',
    '08542',
    '08543',
    '08544',
    '08550',
    '08561',
    '08601',
    '08607',
    '08608',
    '08609',
    '08610',
    '08611',
    '08618',
    '08619',
    '08620',
    '08625',
    '08628',
    '08629',
    '08638',
    '08648',
    '08650',
    '08690',
    '08691',
    '08810',
    '08812',
    '08816',
    '08817',
    '08818',
    '08820',
    '08823',
    '08824',
    '08828',
    '08830',
    '08831',
    '08832',
    '08837',
    '08840',
    '08846',
    '08850',
    '08852',
    '08854',
    '08855',
    '08857',
    '08859',
    '08861',
    '08862',
    '08863',
    '08871',
    '08872',
    '08875',
    '08879',
    '08880',
    '08882',
    '08884',
    '08890',
    '08899',
    '08901',
    '08902',
    '08903',
    '08904',
    '08906',
    '11701',
  ],
  DENVER: [
    '80001',
    '80002',
    '80003',
    '80004',
    '80005',
    '80006',
    '80007',
    '80020',
    '80021',
    '80022',
    '80023',
    '80024',
    '80025',
    '80026',
    '80030',
    '80031',
    '80033',
    '80034',
    '80035',
    '80036',
    '80037',
    '80038',
    '80101',
    '80102',
    '80103',
    '80104',
    '80105',
    '80106',
    '80107',
    '80108',
    '80109',
    '80110',
    '80111',
    '80112',
    '80113',
    '80116',
    '80117',
    '80118',
    '80124',
    '80131',
    '80132',
    '80133',
    '80134',
    '80135',
    '80136',
    '80137',
    '80138',
    '80150',
    '80155',
    '80201',
    '80202',
    '80203',
    '80204',
    '80205',
    '80206',
    '80207',
    '80208',
    '80209',
    '80210',
    '80211',
    '80212',
    '80214',
    '80215',
    '80216',
    '80217',
    '80218',
    '80219',
    '80220',
    '80221',
    '80222',
    '80223',
    '80224',
    '80225',
    '80226',
    '80227',
    '80228',
    '80229',
    '80230',
    '80231',
    '80232',
    '80233',
    '80234',
    '80235',
    '80236',
    '80237',
    '80238',
    '80239',
    '80241',
    '80246',
    '80247',
    '80249',
    '80260',
    '80261',
    '80263',
    '80264',
    '80265',
    '80266',
    '80274',
    '80290',
    '80291',
    '80293',
    '80294',
    '80301',
    '80302',
    '80303',
    '80304',
    '80305',
    '80306',
    '80308',
    '80309',
    '80310',
    '80314',
    '80401',
    '80402',
    '80403',
    '80419',
    '80421',
    '80422',
    '80425',
    '80427',
    '80429',
    '80430',
    '80432',
    '80433',
    '80434',
    '80436',
    '80437',
    '80438',
    '80439',
    '80440',
    '80442',
    '80443',
    '80444',
    '80446',
    '80447',
    '80448',
    '80449',
    '80452',
    '80453',
    '80454',
    '80455',
    '80456',
    '80457',
    '80461',
    '80465',
    '80466',
    '80468',
    '80470',
    '80471',
    '80474',
    '80476',
    '80477',
    '80480',
    '80481',
    '80498',
    '80501',
    '80502',
    '80503',
    '80504',
    '80511',
    '80513',
    '80514',
    '80516',
    '80517',
    '80520',
    '80521',
    '80522',
    '80523',
    '80524',
    '80525',
    '80526',
    '80528',
    '80530',
    '80534',
    '80537',
    '80538',
    '80539',
    '80540',
    '80542',
    '80543',
    '80545',
    '80550',
    '80551',
    '80601',
    '80602',
    '80603',
    '80614',
    '80615',
    '80620',
    '80621',
    '80631',
    '80632',
    '80634',
    '80639',
    '80640',
    '80642',
    '80643',
    '80646',
    '80651',
    '80757',
    '80758',
    '80808',
    '80810',
    '80813',
    '80814',
    '80817',
    '80828',
    '80829',
    '80831',
    '80840',
    '80863',
    '80866',
    '81040',
    '81047',
    '81155',
    '81226',
    '81231',
    '81252',
    '81326',
    '81401',
    '81403',
    '81433',
    '81435',
    '81601',
    '81611',
    '81621',
    '81623',
    '81645',
  ],
  FALL_RIVER: [
    '01082',
    '01504',
    '01529',
    '02018',
    '02019',
    '02032',
    '02035',
    '02038',
    '02048',
    '02052',
    '02053',
    '02054',
    '02056',
    '02060',
    '02067',
    '02070',
    '02071',
    '02072',
    '02081',
    '02093',
    '02322',
    '02334',
    '02340',
    '02343',
    '02348',
    '02356',
    '02357',
    '02375',
    '02456',
    '02634',
    '02637',
    '02702',
    '02703',
    '02712',
    '02714',
    '02715',
    '02717',
    '02718',
    '02719',
    '02720',
    '02721',
    '02722',
    '02723',
    '02724',
    '02725',
    '02726',
    '02740',
    '02743',
    '02744',
    '02745',
    '02746',
    '02747',
    '02748',
    '02760',
    '02761',
    '02762',
    '02763',
    '02764',
    '02766',
    '02767',
    '02769',
    '02771',
    '02777',
    '02779',
    '02780',
    '02790',
    '02791',
    '02801',
    '02802',
    '02804',
    '02806',
    '02808',
    '02809',
    '02812',
    '02813',
    '02814',
    '02815',
    '02816',
    '02817',
    '02818',
    '02822',
    '02823',
    '02824',
    '02825',
    '02826',
    '02827',
    '02828',
    '02829',
    '02830',
    '02831',
    '02832',
    '02833',
    '02835',
    '02836',
    '02837',
    '02838',
    '02839',
    '02840',
    '02841',
    '02842',
    '02852',
    '02857',
    '02858',
    '02859',
    '02860',
    '02861',
    '02862',
    '02863',
    '02864',
    '02865',
    '02871',
    '02873',
    '02874',
    '02875',
    '02876',
    '02877',
    '02878',
    '02879',
    '02880',
    '02881',
    '02882',
    '02883',
    '02885',
    '02886',
    '02887',
    '02888',
    '02889',
    '02891',
    '02892',
    '02893',
    '02894',
    '02895',
    '02896',
    '02898',
    '02901',
    '02902',
    '02903',
    '02904',
    '02905',
    '02906',
    '02907',
    '02908',
    '02909',
    '02910',
    '02911',
    '02912',
    '02914',
    '02915',
    '02916',
    '02917',
    '02918',
    '02919',
    '02920',
    '02921',
    '02940',
    '03458',
    '04210',
    '06001',
    '06062',
    '06119',
    '06416',
  ],
  GRAND_RAPIDS: [
    '45742',
    '48735',
    '48801',
    '48804',
    '48809',
    '48811',
    '48812',
    '48815',
    '48818',
    '48829',
    '48832',
    '48834',
    '48838',
    '48845',
    '48846',
    '48847',
    '48849',
    '48850',
    '48851',
    '48852',
    '48856',
    '48858',
    '48859',
    '48860',
    '48865',
    '48870',
    '48871',
    '48873',
    '48877',
    '48878',
    '48881',
    '48884',
    '48885',
    '48886',
    '48887',
    '48888',
    '48889',
    '48891',
    '48893',
    '48896',
    '48897',
    '49058',
    '49070',
    '49301',
    '49302',
    '49304',
    '49305',
    '49306',
    '49307',
    '49309',
    '49310',
    '49311',
    '49312',
    '49315',
    '49316',
    '49317',
    '49318',
    '49319',
    '49320',
    '49321',
    '49322',
    '49323',
    '49325',
    '49326',
    '49328',
    '49329',
    '49330',
    '49331',
    '49332',
    '49333',
    '49335',
    '49336',
    '49337',
    '49338',
    '49339',
    '49340',
    '49341',
    '49342',
    '49343',
    '49344',
    '49345',
    '49346',
    '49347',
    '49348',
    '49349',
    '49351',
    '49355',
    '49357',
    '49401',
    '49404',
    '49405',
    '49406',
    '49409',
    '49410',
    '49411',
    '49412',
    '49413',
    '49415',
    '49416',
    '49417',
    '49418',
    '49419',
    '49422',
    '49423',
    '49424',
    '49426',
    '49427',
    '49428',
    '49429',
    '49430',
    '49431',
    '49434',
    '49435',
    '49440',
    '49441',
    '49442',
    '49443',
    '49444',
    '49445',
    '49448',
    '49451',
    '49453',
    '49454',
    '49456',
    '49457',
    '49458',
    '49460',
    '49461',
    '49463',
    '49464',
    '49468',
    '49501',
    '49502',
    '49503',
    '49504',
    '49505',
    '49506',
    '49507',
    '49508',
    '49509',
    '49510',
    '49512',
    '49514',
    '49515',
    '49516',
    '49518',
    '49519',
    '49523',
    '49525',
    '49530',
    '49534',
    '49544',
    '49546',
    '49548',
    '49555',
    '49560',
    '49588',
    '49599',
    '49601',
    '49610',
    '49611',
    '49613',
    '49614',
    '49617',
    '49619',
    '49620',
    '49623',
    '49625',
    '49626',
    '49627',
    '49628',
    '49631',
    '49634',
    '49635',
    '49636',
    '49637',
    '49639',
    '49640',
    '49642',
    '49643',
    '49645',
    '49646',
    '49648',
    '49649',
    '49650',
    '49653',
    '49655',
    '49656',
    '49660',
    '49665',
    '49667',
    '49668',
    '49675',
    '49677',
    '49679',
    '49680',
    '49683',
    '49684',
    '49685',
    '49686',
    '49688',
    '49689',
    '49701',
    '49706',
    '49709',
    '49712',
    '49718',
    '49721',
    '49727',
    '49743',
    '49747',
    '49749',
    '49764',
    '49765',
    '49770',
    '49776',
    '49781',
    '49808',
    '49834',
    '49864',
    '49917',
    '49945',
  ],
  MINNEAPOLIS: [
    '50402',
    '50520',
    '53183',
    '54002',
    '54010',
    '54011',
    '54015',
    '54016',
    '54017',
    '54020',
    '54021',
    '54022',
    '54023',
    '54025',
    '54026',
    '54028',
    '54082',
    '54101',
    '54128',
    '54166',
    '54749',
    '54816',
    '55001',
    '55003',
    '55005',
    '55008',
    '55009',
    '55011',
    '55012',
    '55013',
    '55014',
    '55016',
    '55017',
    '55018',
    '55019',
    '55020',
    '55021',
    '55024',
    '55025',
    '55031',
    '55032',
    '55033',
    '55036',
    '55037',
    '55038',
    '55040',
    '55042',
    '55043',
    '55044',
    '55045',
    '55046',
    '55047',
    '55053',
    '55054',
    '55055',
    '55056',
    '55057',
    '55060',
    '55063',
    '55065',
    '55066',
    '55067',
    '55068',
    '55069',
    '55070',
    '55073',
    '55074',
    '55076',
    '55077',
    '55078',
    '55079',
    '55080',
    '55082',
    '55083',
    '55085',
    '55088',
    '55089',
    '55090',
    '55092',
    '55150',
    '55301',
    '55302',
    '55303',
    '55304',
    '55305',
    '55306',
    '55307',
    '55309',
    '55310',
    '55311',
    '55312',
    '55313',
    '55314',
    '55315',
    '55316',
    '55317',
    '55318',
    '55321',
    '55322',
    '55323',
    '55324',
    '55325',
    '55327',
    '55328',
    '55329',
    '55330',
    '55331',
    '55332',
    '55333',
    '55334',
    '55337',
    '55338',
    '55339',
    '55340',
    '55341',
    '55343',
    '55344',
    '55345',
    '55346',
    '55347',
    '55348',
    '55349',
    '55350',
    '55352',
    '55354',
    '55356',
    '55357',
    '55358',
    '55359',
    '55360',
    '55361',
    '55363',
    '55364',
    '55367',
    '55369',
    '55372',
    '55373',
    '55374',
    '55375',
    '55376',
    '55377',
    '55378',
    '55379',
    '55381',
    '55384',
    '55386',
    '55387',
    '55388',
    '55390',
    '55391',
    '55392',
    '55394',
    '55395',
    '55396',
    '55397',
    '55399',
    '55401',
    '55402',
    '55403',
    '55404',
    '55405',
    '55406',
    '55407',
    '55408',
    '55409',
    '55410',
    '55411',
    '55412',
    '55413',
    '55414',
    '55415',
    '55416',
    '55417',
    '55418',
    '55419',
    '55420',
    '55421',
    '55422',
    '55423',
    '55424',
    '55425',
    '55426',
    '55427',
    '55428',
    '55429',
    '55430',
    '55431',
    '55432',
    '55433',
    '55434',
    '55435',
    '55436',
    '55437',
    '55438',
    '55439',
    '55440',
    '55441',
    '55442',
    '55443',
    '55444',
    '55445',
    '55446',
    '55447',
    '55448',
    '55449',
    '55450',
    '55454',
    '55455',
    '55458',
    '55467',
    '55472',
    '55474',
    '55479',
    '55480',
    '55484',
    '55486',
    '55487',
    '55488',
    '55551',
    '55554',
    '55612',
    '55616',
    '55734',
    '55921',
    '55940',
    '55946',
    '55963',
    '55964',
    '55972',
    '56001',
    '56003',
    '56010',
    '56011',
    '56024',
    '56028',
    '56033',
    '56034',
    '56037',
    '56042',
    '56048',
    '56050',
    '56055',
    '56058',
    '56063',
    '56065',
    '56068',
    '56071',
    '56074',
    '56080',
    '56082',
    '56090',
    '56091',
    '56097',
    '56143',
    '56338',
    '56358',
    '56431',
    '56444',
    '56472',
    '56570',
    '56573',
    '56636',
    '56714',
  ],
  NORTHERN_VIRGINIA: [
    '20044',
    '20102',
    '20104',
    '20105',
    '20108',
    '20109',
    '20110',
    '20111',
    '20112',
    '20113',
    '20120',
    '20121',
    '20122',
    '20124',
    '20129',
    '20132',
    '20134',
    '20136',
    '20137',
    '20141',
    '20143',
    '20146',
    '20147',
    '20148',
    '20151',
    '20152',
    '20153',
    '20155',
    '20156',
    '20158',
    '20159',
    '20164',
    '20165',
    '20166',
    '20167',
    '20168',
    '20169',
    '20170',
    '20171',
    '20172',
    '20175',
    '20176',
    '20177',
    '20181',
    '20182',
    '20184',
    '20189',
    '20190',
    '20191',
    '20192',
    '20194',
    '20195',
    '20197',
    '20880',
    '22003',
    '22009',
    '22015',
    '22025',
    '22026',
    '22027',
    '22030',
    '22031',
    '22032',
    '22033',
    '22037',
    '22038',
    '22039',
    '22040',
    '22041',
    '22042',
    '22043',
    '22044',
    '22046',
    '22060',
    '22066',
    '22067',
    '22079',
    '22101',
    '22102',
    '22103',
    '22106',
    '22107',
    '22116',
    '22118',
    '22121',
    '22122',
    '22124',
    '22125',
    '22150',
    '22151',
    '22152',
    '22153',
    '22159',
    '22161',
    '22172',
    '22180',
    '22181',
    '22182',
    '22183',
    '22185',
    '22191',
    '22192',
    '22193',
    '22194',
    '22195',
    '22199',
    '22201',
    '22202',
    '22203',
    '22204',
    '22205',
    '22206',
    '22207',
    '22209',
    '22210',
    '22211',
    '22213',
    '22219',
    '22227',
    '23066',
    '26804',
  ],
  PHILADELPHIA: [
    '07462',
    '07932',
    '08001',
    '08002',
    '08003',
    '08004',
    '08007',
    '08009',
    '08010',
    '08011',
    '08012',
    '08014',
    '08015',
    '08016',
    '08018',
    '08019',
    '08020',
    '08021',
    '08022',
    '08025',
    '08026',
    '08027',
    '08028',
    '08029',
    '08030',
    '08031',
    '08032',
    '08033',
    '08034',
    '08035',
    '08036',
    '08037',
    '08039',
    '08041',
    '08043',
    '08045',
    '08046',
    '08048',
    '08049',
    '08051',
    '08052',
    '08053',
    '08054',
    '08055',
    '08056',
    '08057',
    '08059',
    '08060',
    '08061',
    '08062',
    '08063',
    '08064',
    '08065',
    '08066',
    '08067',
    '08068',
    '08070',
    '08071',
    '08072',
    '08073',
    '08075',
    '08077',
    '08078',
    '08080',
    '08081',
    '08083',
    '08084',
    '08085',
    '08086',
    '08088',
    '08089',
    '08090',
    '08091',
    '08093',
    '08094',
    '08095',
    '08096',
    '08097',
    '08098',
    '08099',
    '08101',
    '08102',
    '08103',
    '08104',
    '08105',
    '08106',
    '08107',
    '08108',
    '08109',
    '08110',
    '08204',
    '08212',
    '08221',
    '08223',
    '08224',
    '08225',
    '08312',
    '08318',
    '08321',
    '08322',
    '08328',
    '08343',
    '08344',
    '08505',
    '08511',
    '08515',
    '08518',
    '08554',
    '08562',
    '08640',
    '13078',
    '16422',
    '17959',
    '18039',
    '18041',
    '18054',
    '18070',
    '18073',
    '18074',
    '18076',
    '18081',
    '18322',
    '18332',
    '18334',
    '18337',
    '18901',
    '18902',
    '18910',
    '18911',
    '18912',
    '18913',
    '18914',
    '18915',
    '18916',
    '18917',
    '18918',
    '18920',
    '18921',
    '18922',
    '18923',
    '18924',
    '18925',
    '18927',
    '18928',
    '18929',
    '18930',
    '18931',
    '18932',
    '18933',
    '18934',
    '18935',
    '18936',
    '18938',
    '18940',
    '18942',
    '18943',
    '18944',
    '18946',
    '18947',
    '18949',
    '18950',
    '18951',
    '18953',
    '18954',
    '18955',
    '18956',
    '18957',
    '18958',
    '18960',
    '18962',
    '18963',
    '18964',
    '18966',
    '18968',
    '18969',
    '18970',
    '18971',
    '18972',
    '18974',
    '18976',
    '18977',
    '18979',
    '18980',
    '18981',
    '19001',
    '19002',
    '19003',
    '19004',
    '19006',
    '19007',
    '19008',
    '19010',
    '19012',
    '19013',
    '19014',
    '19015',
    '19017',
    '19018',
    '19020',
    '19021',
    '19022',
    '19023',
    '19025',
    '19026',
    '19027',
    '19028',
    '19029',
    '19030',
    '19031',
    '19032',
    '19033',
    '19034',
    '19035',
    '19036',
    '19037',
    '19038',
    '19040',
    '19041',
    '19043',
    '19044',
    '19046',
    '19047',
    '19049',
    '19050',
    '19052',
    '19053',
    '19054',
    '19055',
    '19056',
    '19057',
    '19058',
    '19060',
    '19061',
    '19063',
    '19064',
    '19065',
    '19066',
    '19067',
    '19070',
    '19072',
    '19073',
    '19074',
    '19075',
    '19076',
    '19078',
    '19079',
    '19081',
    '19082',
    '19083',
    '19085',
    '19086',
    '19087',
    '19090',
    '19094',
    '19095',
    '19096',
    '19101',
    '19102',
    '19103',
    '19104',
    '19105',
    '19106',
    '19107',
    '19108',
    '19109',
    '19110',
    '19111',
    '19112',
    '19113',
    '19114',
    '19115',
    '19116',
    '19118',
    '19119',
    '19120',
    '19121',
    '19122',
    '19123',
    '19124',
    '19125',
    '19126',
    '19127',
    '19128',
    '19129',
    '19130',
    '19131',
    '19132',
    '19133',
    '19134',
    '19135',
    '19136',
    '19137',
    '19138',
    '19139',
    '19140',
    '19141',
    '19142',
    '19143',
    '19144',
    '19145',
    '19146',
    '19147',
    '19148',
    '19149',
    '19150',
    '19151',
    '19152',
    '19153',
    '19154',
    '19161',
    '19173',
    '19176',
    '19182',
    '19184',
    '19187',
    '19188',
    '19190',
    '19191',
    '19194',
    '19301',
    '19312',
    '19319',
    '19331',
    '19333',
    '19339',
    '19340',
    '19342',
    '19355',
    '19373',
    '19399',
    '19401',
    '19403',
    '19404',
    '19405',
    '19406',
    '19407',
    '19408',
    '19409',
    '19421',
    '19422',
    '19423',
    '19424',
    '19425',
    '19426',
    '19428',
    '19429',
    '19430',
    '19432',
    '19435',
    '19436',
    '19437',
    '19438',
    '19440',
    '19441',
    '19442',
    '19443',
    '19444',
    '19446',
    '19450',
    '19451',
    '19453',
    '19454',
    '19455',
    '19456',
    '19457',
    '19460',
    '19462',
    '19464',
    '19465',
    '19468',
    '19473',
    '19474',
    '19475',
    '19477',
    '19478',
    '19481',
    '19482',
    '19484',
    '19486',
    '19490',
    '19492',
    '19493',
    '19494',
    '19525',
    '19548',
    '19735',
  ],
};

export type LocalPageZipsConstants = typeof localPageZipConstants;
export const localPageZipConstantsToken =
  new InjectionToken<LocalPageZipsConstants>('localPageZipConstantsToken');
export default localPageZipConstants;
